import type { AdminResponses } from "@tfg/types/endpoints/admin"

type PlanSettingKey = keyof AdminResponses.OrganizationSettings

type PlanSettingOption = {
  readonly labelTranslationKey: string
  readonly value: string
}

type PlanSettingConfig = {
  readonly planKey: PlanSettingKey
  readonly labelTranslationKey: string
  readonly options: readonly PlanSettingOption[]
}

export const PLAN_SETTING_CONFIGS = [
  {
    planKey: "agecProductPagePlan",
    labelTranslationKey: "plan.agecProductPagePlan.label",
    options: [
      {
        labelTranslationKey: "plan.agecProductPagePlan.starter",
        value: "STARTER",
      },
      {
        labelTranslationKey: "plan.agecProductPagePlan.essential",
        value: "ESSENTIAL",
      },
      {
        labelTranslationKey: "plan.agecProductPagePlan.advanced",
        value: "ADVANCED",
      },
    ],
  },
  {
    planKey: "outputCustomizationPlan",
    labelTranslationKey: "plan.outputCustomizationPlan.label",
    options: [
      {
        labelTranslationKey: "plan.outputCustomizationPlan.essential",
        value: "ESSENTIAL",
      },
      {
        labelTranslationKey: "plan.outputCustomizationPlan.advanced",
        value: "ADVANCED",
      },
      {
        labelTranslationKey: "plan.outputCustomizationPlan.expert",
        value: "EXPERT",
      },
    ],
  },
  {
    planKey: "lcaCustomizationPlan",
    labelTranslationKey: "plan.lcaCustomizationPlan.label",
    options: [
      {
        labelTranslationKey: "plan.lcaCustomizationPlan.advanced",
        value: "ADVANCED",
      },
      {
        labelTranslationKey: "plan.lcaCustomizationPlan.expert",
        value: "EXPERT",
      },
    ],
  },
  {
    planKey: "customFieldsPlan",
    labelTranslationKey: "plan.customFieldsPlan.label",
    options: [
      {
        labelTranslationKey: "plan.customFieldsPlan.advanced",
        value: "ADVANCED",
      },
      { labelTranslationKey: "plan.customFieldsPlan.expert", value: "EXPERT" },
    ],
  },
  {
    planKey: "certificatesPlan",
    labelTranslationKey: "plan.certificatesPlan.label",
    options: [
      {
        labelTranslationKey: "plan.certificatesPlan.advanced",
        value: "ADVANCED",
      },
      { labelTranslationKey: "plan.certificatesPlan.expert", value: "EXPERT" },
    ],
  },
  {
    planKey: "zalandoPlan",
    labelTranslationKey: "plan.zalandoPlan.label",
    options: [
      { labelTranslationKey: "plan.zalandoPlan.no", value: "DISABLED" },
      { labelTranslationKey: "plan.zalandoPlan.yes", value: "ENABLED" },
    ],
  },
  {
    planKey: "rduePlan",
    labelTranslationKey: "plan.rduePlan.label",
    options: [
      { labelTranslationKey: "plan.rduePlan.no", value: "DISABLED" },
      { labelTranslationKey: "plan.rduePlan.yes", value: "ENABLED" },
    ],
  },
] as const satisfies readonly PlanSettingConfig[]

export type PlanSettingConfigItem = (typeof PLAN_SETTING_CONFIGS)[number]
